import type { AppDefinition } from '../types';

/** SAP — enterprise ERP. No connector yet. */
export const SAP_APP: AppDefinition = {
  id: 'sap',
  nameKey: 'apps.sap.name',
  descriptionKey: 'apps.sap.description',
  logo: '/images/apps/sap-logo.svg',
  categories: ['erp'],
  status: 'soon',
  label: 'soon',
};
